module.exports = __webpack_public_path__ + "img/45.2.TN.470c3c4e.png";